import { Location } from '@cobliteam/common-types';
import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

const PathAssociationPage = lazy(() => import('./PathAssociationPage'));
const VehiclePathsPage = lazy(() => import('./VehiclePathsPage'));

const PathAssociationRouter = () => {
  return (
    <Switch>
      <Route path={Location.PATH_ASSOCIATION} exact>
        <PathAssociationPage />
      </Route>
      <Route path={Location.PATH_ASSOCIATION_VEHICLE} exact>
        <VehiclePathsPage />
      </Route>
    </Switch>
  );
};

export default PathAssociationRouter;
